export enum item{
    compass,
    map,
    key1,
    key2,
    key3,
    egg,
    cannonball,
    matches
}